import React, {useRef, useState} from "react";

import styles from './dataInput.module.css'
import translation from "../../Helpers/translation";
import SlideUpDown from "../../Helpers/slideUpDown/slideUpDown";
import {useHistory, useLocation} from "react-router-dom";
import queryString from "query-string";
import {searchHandle} from "../../Helpers/functions";
import useOnclickOutside from "react-cool-onclickoutside";

function DataInput(props) {

    const inputRef = useRef()
    const location = useLocation()
    const history = useHistory();
    const queryParams = queryString.parse(location.search)
    const [closed, setClosed] = useState(true);
    const [data, setData] = useState(props.data)
    const [inputValue, setInputValue] = useState(props.selected ? props.selected : queryParams[props.type] ? queryParams[props.type] : '')
    const [selected, setSelected] = useState(props.search ? !!queryParams[props.type] : false)

    const setHandle = (item) => {
        if(props.search) {
            searchHandle(props.type, item.id, "string", location, history, queryParams);
            setInputValue(item.id)
            setSelected(true)
        } else {
            props.setSelected(item.id)
            setInputValue(item.id)
        }

        setClosed(true)
    }

    const onChangeHandle = (event) => {
        let value = event.target.value.replace(/\D/g, "")

        if(value.length <= 4) {
            if(!props.search) {
                props.setSelected(value)
            } else {
                setSelected(true)
            }

            setInputValue(value)
            setData(props.data.filter((year) => year.id.toString().includes(value)))
            setClosed(false)
        } else {
            setTimeout(() => {
                setClosed(true)
            },100)
        }
    }

    const keyDownHandle = (event) => {
        if(event.key === "Enter" && props.search) {
            searchHandle(props.type, inputValue, "string", location, history, queryParams);

            if (inputValue !== '') {
                setSelected(true)
            } else {
                setSelected(false)
            }
        }
    }

    return (
        <div className={styles.container} ref={useOnclickOutside(() => setClosed(true))}>
            <div className={`${styles.openSort} ${props.selected ? styles.active : selected ? styles.active : ''}`} onClick={() => inputRef.current.focus()}>
                <label className={styles.label}>
                    <span className={styles.pre}>{props.type === "title" ? translation.all.title : props.type === "sender" ? translation.all.sender : props.type === "addressee" ? translation.all.addressee : props.type === "yearsFrom" ? translation.all.yearsFrom : translation.all.yearsTo}</span>
                    <input className={styles.textInput} type={"text"} onChange={onChangeHandle} value={inputValue} ref={inputRef} onKeyDown={keyDownHandle}/>
                </label>
            </div>
            <div className={styles.sortOptionsContainer}>
                <SlideUpDown closed={closed} closedStart={true}>
                    <div className={styles.sortOptionsWrapper}>
                        {data.map((item, index) => {
                            return (
                                <button key={index} type={"button"} className={styles.option} onClick={() => setHandle(item)}>
                                    <span className={styles.label}>
                                        <span className={styles.value}>
                                            {item.name}
                                        </span>
                                    </span>
                                </button>
                            )
                        })}
                    </div>
                </SlideUpDown>
            </div>
        </div>
    )
}

export default DataInput